<template>
  <v-container class="pay-result" style="max-width: 520px">
    <v-card class="pa-6 text-center" elevation="2" style="border-radius: 20px">
      <template v-if="state === 'loading'">
        <v-progress-circular indeterminate color="primary" size="48" class="mb-4"></v-progress-circular>
        <h2 class="text-h6">Confirmando tu pago…</h2>
        <p class="grey--text text--darken-1 mb-0">Esto tarda unos segundos. No cierres esta página.</p>
      </template>

      <template v-else-if="state === 'approved'">
        <v-icon size="64" color="success" class="mb-2">mdi-check-circle</v-icon>
        <h2 class="text-h5 font-weight-bold mb-1">¡Pago recibido!</h2>
        <p class="mb-1">Tu pedido fue enviado a <strong>{{ result.storeName }}</strong>.</p>
        <p class="grey--text text--darken-1">Total pagado: <strong>{{ result.total | currency }}</strong></p>
        <v-btn color="primary" depressed large class="mt-2" to="/orders">Ver mis pedidos</v-btn>
      </template>

      <template v-else-if="state === 'pending'">
        <v-icon size="64" color="amber darken-2" class="mb-2">mdi-timer-sand</v-icon>
        <h2 class="text-h5 font-weight-bold mb-1">Tu pago está en proceso</h2>
        <p class="grey--text text--darken-1">Algunos pagos, como PSE, tardan unos minutos en confirmarse. Cuando se apruebe, tu pedido llegará al comercio.</p>
        <v-btn color="primary" depressed class="mt-2 mr-2" :loading="checking" @click="check">Actualizar estado</v-btn>
        <v-btn text class="mt-2" to="/orders">Mis pedidos</v-btn>
      </template>

      <template v-else-if="state === 'declined'">
        <v-icon size="64" color="error" class="mb-2">mdi-close-circle</v-icon>
        <h2 class="text-h5 font-weight-bold mb-1">El pago no fue aprobado</h2>
        <p class="grey--text text--darken-1">No te cobramos nada. Puedes intentarlo de nuevo con otro medio de pago.</p>
        <v-btn color="primary" depressed large class="mt-2" :loading="retrying" @click="retry">Reintentar el pago</v-btn>
        <div><v-btn text class="mt-2" to="/orders">Ver mis pedidos</v-btn></div>
      </template>

      <template v-else>
        <v-icon size="64" color="grey" class="mb-2">mdi-alert-circle-outline</v-icon>
        <h2 class="text-h6 mb-1">No pudimos revisar tu pago</h2>
        <p class="grey--text text--darken-1">{{ errorText }}</p>
        <v-btn color="primary" depressed class="mt-2 mr-2" :loading="checking" @click="check">Intentar de nuevo</v-btn>
        <v-btn text class="mt-2" to="/orders">Mis pedidos</v-btn>
      </template>
    </v-card>
  </v-container>
</template>

<script>
import Parse from 'parse'

export default {
  name: 'PayResult',
  data: () => ({ state: 'loading', result: {}, errorText: '', checking: false, retrying: false, tries: 0, timer: null }),
  mounted () { this.check() },
  beforeDestroy () { clearTimeout(this.timer) },
  methods: {
    async check () {
      this.checking = true
      try {
        const res = await Parse.Cloud.run('confirmWompiPaymentBO', { orderId: this.$route.params.order_id, transactionId: this.$route.query.id })
        this.result = res
        if (res.status === 'APPROVED') this.state = 'approved'
        else if (res.status === 'DECLINED' || res.status === 'VOIDED' || res.status === 'ERROR') this.state = 'declined'
        else {
          this.state = this.tries < 6 ? 'loading' : 'pending'
          if (this.tries < 6) {
            this.tries += 1
            this.timer = setTimeout(this.check, 4000)
          }
        }
      } catch (e) {
        this.state = 'error'
        this.errorText = (e && e.message) || 'Inténtalo de nuevo en un momento.'
      } finally {
        this.checking = false
      }
    },
    async retry () {
      this.retrying = true
      try {
        const checkout = await Parse.Cloud.run('getWompiCheckoutBO', { orderId: this.$route.params.order_id })
        window.location.href = checkout.url
      } catch (e) {
        this.state = 'error'
        this.errorText = (e && e.message) || 'No pudimos abrir el pago.'
      } finally {
        this.retrying = false
      }
    }
  }
}
</script>
